// @flow

import React from "react";
import ReactDOM from "react-dom";

import HelloAnimation from "../components/HelloAnimation";

const els = document.querySelectorAll("#hello-animation");
els.forEach((el: HTMLElement) => {
    ReactDOM.render(
        <HelloAnimation
            images={[
                "arabic.svg",
                "chinese.svg",
                "dari.svg",
                "english.svg",
                "tamil.svg",
                "turkish.svg",
            ]}
        />,
        el
    );
});
